<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 16 16"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M9.462 2.378l6.303 8.772A1.8 1.8 0 0 1 14.303 14H1.696a1.8 1.8 0 0 1-1.461-2.85l6.303-8.772a1.8 1.8 0 0 1 2.924 0z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
